export type CareRecipientMatchStatus = 'matched' | 'suggested' | 'unmatched' | 'conflict' | 'unlinked' | 'ignored';

export interface CareRecipientClientRef {
  client_id: number;
  client_name: string | null;
  disabled: boolean;
}

export interface CareRecipientConflictClient {
  client_id: number;
  client_name: string | null;
}

export interface CareRecipient {
  id: string;
  care_recipient_id: string;
  first_name: string | null;
  middle_name: string | null;
  last_name: string | null;
  name: string;
  // Bare calendar date, `YYYY-MM-DD`.
  birth_date: string | null;
  gender: string | null;
  in_care: boolean | null;
  is_ignored: boolean;
  match_status: CareRecipientMatchStatus;
  linked_client: CareRecipientClientRef | null;
  suggested_client: CareRecipientClientRef | null;
  conflict_clients: CareRecipientConflictClient[];
}

export interface CareRecipientListResponse {
  rows: CareRecipient[];
  total: number;
  counter: number;
  meta: { last_synced_at: string | null };
}

export interface CareRecipientListQuery {
  is_ignored?: boolean;
  in_care?: boolean;
  limit?: number;
  offset?: number;
  sortBy?: 'care_recipient_id' | 'name' | 'birth_date';
  sortOrder?: 'asc' | 'desc';
}

export interface CareRecipientSyncResult {
  fetched: number;
  // Null when the PRODA connection has no NAPS ID.
  in_care: number | null;
  in_care_available: boolean;
  truncated: boolean;
  synced_at: string;
  created: number;
  updated: number;
  pruned: number;
}

export interface LinkableClient {
  id: number;
  name: string;
  disabled: boolean;
}

export interface CareRecipientLinkResult {
  changed: boolean;
  client_id: number;
  client_name: string | null;
  old_medicare_identifier: string | null;
  new_medicare_identifier: string | null;
}

export interface CareRecipientUnlinkResult {
  changed: boolean;
  client_id: number | null;
}

export interface CareRecipientIgnoreResult {
  id: string;
  care_recipient_id: string;
  is_ignored: boolean;
  changed: boolean;
}

// Services Australia gender codes. X is shown as "Intersex or unspecified" (confirmed 22 Oct 2026).
export const CARE_RECIPIENT_GENDER_NAMES: Record<string, string> = {
  M: 'Male',
  F: 'Female',
  X: 'Intersex or unspecified',
  U: 'Unknown',
};
